import { render, staticRenderFns } from "./FreeAccountNotificationBar.vue?vue&type=template&id=b6ef7ba0&"
import script from "./FreeAccountNotificationBar.vue?vue&type=script&lang=ts&"
export * from "./FreeAccountNotificationBar.vue?vue&type=script&lang=ts&"
import style0 from "./FreeAccountNotificationBar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports